export * from './M22Brands';
export { M22Brands as default } from './M22Brands';
